/*
 * Public API Surface of ngx-lib/select
 */
export * from './select.module';
export * from './select.component';
